import FieldDefs from './BackLinksAnchorFieldDefs'
import {doLangFields} from '../../lib/ks-tools'

export default {
    template: `<div><slot v-bind="self" /></div>`,
    data() {
        return {
            fields: doLangFields(this, "lang.report.backlinks_anchor.fields", FieldDefs),
            sortOrder: [
                {
                    field: 'backlinks_count',
                    direction: 'desc'
                }
            ],
            moreParams: {},
            additionalActions: [],
        }
    },
    props: {
        domain: {
            type: String,
            required: true
        }
    },
    computed: {
        getApiUrl(){
            return '/report/simple/links/backlinks-anchor?domain=' + this.domain;
        },
        self() {
            return this;
        },
    },
}
